import React, {Component} from 'react'
import Main from './views/Main'
import Header from './views/Header'
import Footer from './views/Footer'
import IENotSupported from './views/IENotSupported'
// import {logger} from './store/logger'
import {Card, CardHeader} from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.css';
import './css/osps4.css'
import isIE from './utilities/isIE';

import {reducer} from './store/reducer'

class App extends Component {

  constructor(props) {
    super(props)
    this.state = reducer();
    this.dispatch = this.dispatch.bind(this);
  }

  dispatch(action, payload) {
    this.setState(reducer(this.state, {action, payload}));
  }

  reload() {
    document.location.reload()
  }

  render() {
    if (!isIE()) {
      return (
        <div className="container-fluid">
          <Header {...this.props} {...this.state} dispatch={this.dispatch} />
          {
            (this.state.timeout) ?
              <Card>
                <CardHeader>
                  <h4 className="text-center">Your session has timed out. Please <span className="login-again"
                                                                                       onClick={this.reload}>log in again</span>
                  </h4>
                </CardHeader></Card> :
              // null
              <Main {...this.props} {...this.state} dispatch={this.dispatch} />
          }
          <Footer {...this.props} {...this.state} dispatch={this.dispatch} />
        </div>
      )
    } else {
      return (
        <div className="container-fluid">
          <IENotSupported {...this.state} />
        </div>
      )
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js